import { MpsPanelTemplate } from '@mps/mps-kit/mps-panel';

export const hpc_panel_templates: Record<string, MpsPanelTemplate> = {
  default: {
    id: 'default',
    showHeader: true,
    showFooter: true,
    animateEnter: true,
  },
  outlined: {
    variant: 'outlined',
  },
  filled: {
    variant: 'filled',
  },
  elevated: {
    variant: 'elevated',
  },
  flat: {
    variant: 'flat',
  },

  'panel:view_field_table': {
    contentStylex: {
      xsBackground: 'transparent',
      xsPadding: 'size.xsmall',
      //xsElevation: 'size.small',
    },
    stylex: {
      xsBackground: 'transparent',

      xsBorderWidth: 'size.',
      xsBorderRadius: 'size.none',
    },
    footerStylex: {
      style: {
        //width:'300px'
      },
    },
  },

  debug: {
    stylex: {
      xsBackground: '#f7ef06ff',
      xsPadding: 'size.small',
      xsBorderRadius: 'size.xsmall',
      xsElevation: 'size.medium',
    },

    showHeader: true,
    enableDebug: false,
  },

  field: {
    stylex: {
      xsBackground: '#cb10d9ff',
      xsPadding: 'size.small',
      xsBorderRadius: 'size.medium',
      xsElevation: 'size.medium',
    },
    headerInfoConfig: {
      titleColor: '#ffffff',
      subtitleColor: '#f0c0f0',
    },
    showHeader: true,
  },

  hpc1: {
    headerSeparator: true,
    showHeader: true,
    enableDebug: false,
  },

  'panel:hpc': {
    headerSeparator: true,
    stylex: {
      //xsElevation:'size.medium',
    },

    headerStylex: {
      style: {
        minHeight: '100px',
      },
    },
    showHeader: true,
    enableDebug: false,
  },

  clr_header_peche: {
    id: 'clr_header_peche',
    btemplate: 'clr_header_gris_perle_clair',
    enableDebugTemplate: true,
  },

  clr_header_gris_perle_clair: {
    enableDebugTemplate: true,
  },

  'panel:user': {
    id: 'panel:user',
    headerInfoConfig: {
      titleSize: '28px',
      titleWeight: 'blod',
    },
    headerStylex: {
      //xsBackground : 'color.bg-light-blue',
      xsElevation: 'size.medium',
    },

    contentStylex: {
      xsPadding: 'size.xlarge',
    },
    enableDebugTemplate: true,
    //btemplate:'clr_header_peche',
    //headerSeparator:true,
    showHeader: false,
    enableDebug: false,
  },

  zouma2: {
    headerSeparator: true,
    showHeader: true,
    enableDebug: false,
  },
  'panel:zouma': {
    stylex: {
      //xsPadding: 'size.small',
      //xsBorderRadius  : 'size.medium',
      //xsElevation:'size.medium',
      xsBackground: 'transparent',
    },
    headerStylex: {
      xsBorderRadius: 'size.medium',
      xsBackground: 'color.bg-gaz',
      xsMargin: '0px 0px 10px 0px',
    },
    headerInfoConfig: {
      subtitleColor: '#ffffffff',
    },

    contentStylex: {
      //class:'g-chbani',
      xsBorderRadius: 'size.medium',
      xsBackground: 'color.bg-turquoise',
      xsPadding: 'size.medium',
      xsMargin: '10px 0px 0px 0px',
    },
    footerStylex: {
      xsMargin: '-4px 0px 0px 0px',
      xsBackground: 'color.bg-turquoise',
    },

    headerSeparator: true,
    showHeader: true,
    enableDebug: false,
  },
};
